<template>
<div class="table-container">
    <div class="d-flex">
        <div class="mr-auto">
             <mdb-btn color="elegant" size="sm" @click="clearAllFilters" class="ml-0 mr-0">Clear all filters</mdb-btn>
                <template v-if="hasFilterSlot">
                    <mdb-btn color="elegant" size="sm" @click="openFilterDialog" class="ml-0 mr-0"><i class="el-icon-s-operation"></i> Filter</mdb-btn>
                </template>
                    
                </div>
            <div>

                <el-checkbox
                    v-model="showAll"
                    class="show-all-toggle mr-2"
                    @change="handleShowAllChange"
                >
                    Show Zero Available
                </el-checkbox>

                <mdb-btn color="elegant" size="sm" @click="refreshTable" class="ml-0 mr-0">
                    Refresh Data
                </mdb-btn>

                <mdb-btn
                    v-if="copyBtn"
                    color="elegant"
                    size="sm"
                    class="ml-0 mr-0"
                    :disabled="!modelRowData || !modelRowData.length"
                    @click="copyTable"
                >
                    Copy Table
                </mdb-btn>

                 <el-popover
                    v-model="colPopover"
                    popper-class="colvis-pop"
                    placement="bottom-start"
                    width="260"
                    trigger="click"
                >
                    <div style="margin-bottom:6px">
                        <el-checkbox
                            :indeterminate="isIndeterminateAG"
                            v-model="checkAllAG"
                            @change="onCheckAllAG"
                        >
                            Show all
                        </el-checkbox>
                    </div>

                    <div class="colvis-scroll">
                        <el-checkbox-group v-model="checkedFieldsAG" @change="applyColumnPrefsAG">
                            <el-checkbox
                                v-for="c in columnChoices"
                                :key="c.id"
                                :label="c.id"
                                :disabled="c.locked"
                                class="colvis-item"
                            >
                                {{ c.label }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="margin-top:8px;display:flex;gap:6px">
                    <mdb-btn color="elegant" size="sm"  @click="resetColumnPrefsAG">Reset</mdb-btn>
                    <mdb-btn color="elegant" size="sm"  @click="colPopover=false">Done</mdb-btn>
                    </div>

                    <mdb-btn slot="reference" color="elegant" size="sm" class="ml-0 mr-0">Toggle Columns</mdb-btn>
            </el-popover>

        </div>
    </div>     

    <ag-grid-vue
    v-loading="invloading"
    ref="model"
    class="ag-theme-alpine"
    style="width: 100%; height: calc(100vh - 100px)"
    :columnDefs="columnDefs"
    :rowData="modelRowData"
    :pagination="true"
    :paginationPageSize="100"
    :enableSorting="true"
    :enableFilter="true"
    :defaultColDef="{
        filter: true,
        sortable: true,
        flex: 1,
        resizable: true
    }"
    :rowHeight="64"
    :context="{ vm: this }"
    @grid-ready="onGridReady"
    @row-clicked="onRowClicked"
    @cell-context-menu="handleGridCellContextMenu"
    @contextmenu.native.prevent="suppressBrowserContextMenu"
    />

    <div
        v-if="copyBtn && contextMenu.visible"
        class="inventory-grid-context-menu"
        :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }"
        @click.stop
        @contextmenu.prevent
    >
        <div class="inventory-grid-context-menu-location">
            Row {{ contextMenu.rowIndex }} · {{ contextMenu.header }}
        </div>
        <button type="button" @click="copyContextCell">Copy</button>
        <button type="button" @click="copyContextColumn">Copy Column</button>
        <button type="button" @click="copyContextRow">Copy Row</button>
        <button type="button" @click="copyContextTable">Copy Table</button>
    </div>


<el-dialog title="Filter" :visible.sync="filterDialog" :close-on-click-modal="false" width="40%" size="small" class="text-left filter-form">
    <div class="filter-dalog-body p-4">
        <slot name="filter"></slot>
    </div>
    <div class="filter-dalog-footer border-top border-light">
        <div class="d-flex align-items-center pr-4 pl-4">
            <mdb-btn color="elegant" class="ml-0" size="sm" @click="handleFilterForm"><i class="el-icon-search"></i> Search</mdb-btn>
            <mdb-btn color="elegant" class="ml-0" size="sm" @click="handleClearFilterForm"><i class="el-icon-close"></i> Clear</mdb-btn>
            <mdb-btn color="elegant" class="ml-0" size="sm" @click="closeFilterDialog"><i class="el-icon-close"></i> Close</mdb-btn>
        </div>
    </div>
</el-dialog>

        <CoolLightBox 
            :items="gallery" 
            :index="index"
            :useZoomBar="true"
            @close="index = null">
            </CoolLightBox>

        
        </div>
</template>
<script>
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import {
    mdbIcon,
    mdbContainer,
    mdbBtn,
    mdbFormInline,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbClickOutside, 
    mdbTabs, 
    mdbInput, 
    mdbNavbar,
      mdbNavbarBrand,
      mdbNavbarToggler,
      mdbNavbarNav,
      mdbNavItem,
      mdbBadge
} from "mdbvue";
import { mapGetters, mapMutations,mapActions } from 'vuex';
import { MessageBox , Message} from 'element-ui'
import {token} from '../../helpers/headers'
import { AgGridVue } from 'ag-grid-vue'
import QuantitySetFilter from './QuantitySetFilter.vue'
import QuantityPicker from './QuantityPicker.vue'
import PriceSetFilter from './PriceSetFilter.vue'
import TextSetFilter from './TextSetFilter.vue'
import CopyCell from './CopyCell.vue'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import Vue from 'vue'
// Vue.component('quantitySetFilter', QuantitySetFilter)
const QuantitySetFilterCtor = Vue.extend(QuantityPicker)
const PriceSetFilterCtor = Vue.extend(PriceSetFilter)
const TextSetFilterCtor = Vue.extend(TextSetFilter)
const CopyCellx = Vue.extend(CopyCell)
const vf2 = p => formatMoney(Number(p.value ?? 0), {
  symbol: "", precision: 2, thousand: ",", decimal: "."
})
const promoPriceFormatter = p => {
  const data = p.data || {}
  const silentPrice = Number(data.silent_promo_price)
  const publicPrice = Number(data.public_promo_price)
  const fallbackPrice = Number(p.value)
  const formatPrice = price => formatMoney(Number.isFinite(price) ? price : 0, {
    symbol: "", precision: 2, thousand: ",", decimal: "."
  })
  const lines = []

  if (Number.isFinite(publicPrice) && publicPrice > 0) lines.push(`P : ${formatPrice(publicPrice)}`)
  if (Number.isFinite(silentPrice) && silentPrice > 0) lines.push(`S : ${formatPrice(silentPrice)}`)

  return lines.length ? lines.join('\n') : formatPrice(fallbackPrice)
}
const promoPriceCellRenderer = p => {
  const wrapper = document.createElement('div')
  wrapper.className = 'promo-price-renderer'

  promoPriceFormatter(p).split('\n').forEach(line => {
    const lineElement = document.createElement('div')
    lineElement.textContent = line
    wrapper.appendChild(lineElement)
  })

  return wrapper
}
const pick = (field, header) => ({
    minWidth : 120,
    headerName: header,
    field,
    editable: false,
    filterFramework: QuantitySetFilterCtor,
    filterParams: {
        valuesGetter: ({ api }) => {
        const seen = Object.create(null)
        api.forEachNodeAfterFilter(node => {
            if (!node || !node.data) return
            const n = Number(node.data[field])
            if (!isNaN(n)) seen[n] = true
        })
        return Object.keys(seen).map(k => Number(k)).sort((a, b) => a - b)
        }
    }
})

const pickPrice = (field, header) => ({
    minWidth : 120,
    headerName: header,
    field,
    editable: false,
    filterFramework: PriceSetFilterCtor,
    filterParams: {
        valuesGetter: ({ api }) => {
        const seen = Object.create(null)
        api.forEachNodeAfterFilter(node => {
            if (!node || !node.data) return
            const n = Number(node.data[field])
            if (!isNaN(n)) seen[n] = true
        })
        return Object.keys(seen).map(k => Number(k)).sort((a, b) => a - b)
        }
    }
})


const pickText = (field, header) => ({
  minWidth: 120,
  headerName: header,
  field,
  editable: false,
  filterFramework: TextSetFilterCtor,
  filterParams: {
    valuesGetter: ({ api }) => {
      const seen = Object.create(null)
      const add = (node) => {
        if (!node || !node.data) return
        const raw = node.data[field]
        const s = (raw == null) ? '' : String(raw)
        seen[s] = true
      }

      // collect after existing filters; if empty, fall back to all rows
      api.forEachNodeAfterFilter(add)
      if (!Object.keys(seen).length) api.forEachNode(add)

      const vals = Object.keys(seen)
      vals.sort((a, b) => {
        if (a === '' && b !== '') return -1
        if (b === '' && a !== '') return 1
        return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true })
      })
      return vals
    }
  }
})

const esc = s => String(s ?? '').replace(/&/g,'&amp;')
  .replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')

export default {
    name : "ThatsTable",
    inject : ['brandProvider','categoryProvider','areaProvider','collectionProvider','filteredCategoryProvider','materialProvider','colourMasterProvider','sizeMasterProvider'],
    
    data(){
        return {
            /* frameworkComponents: {
                quantitySetFilter: QuantitySetFilter
            }, */
            toggle : false,
            token : null,
            active : 0,
            showAll : false,
            filterDialog : false,
            loading : false,
            gallery : [],
            index : [],
            // gridApi: { copySelectedRangeToClipboard: () => {} },
            gridApi: null,
            columnApi: null,
            columnDefs: null,
            modelRowData: null,
            contextMenu: {
                visible: false,
                x: 0,
                y: 0,
                rowIndex: 0,
                header: '',
                field: null,
                value: '',
                row: null,
                definition: null
            },
            
            colPopover: false,  
            disabledColumns : [],
            checkedFields: [],
            localLength : 20000,
            checkedFieldsAG: [],
            filterableColumns: [
                "series",
                "name",
                "sale_price",
                "promo_price",
                "available",
                "stock_qty",
                "showroom_qty",
                "git_01",
                 "sr_01",
                "sr_02",
                "sr_03",
                "sr_04",
                "sr_05",
                "sr_06",
                "sr_07",
                "sr_08",
                "sr_09",
                "sr_10",
                "sr_11",
                "sr_12",
                "sr_13",
                "wh_01",
            ],
            numericKeys: [
                "available", "stock_qty", "showroom_qty","git_01",
                "sr_01","sr_02","sr_03","sr_04","sr_05","sr_06","sr_07","sr_08","sr_09","sr_10","sr_11","sr_12","sr_13",
                "wh_01"
            ],
            selectedFilters: { available: [] },
        }
    },

    props : {
        endpoint : {
            type: String,
            required : true,
            default : 'new-item'
        },
        columns : {
            type: Array,
            required : true
        },
        height : {
            type: String,
            default : 'calc(100vh - 140px)'
        },
        filterClass : {
            type: String,
            default : 'sf-dropdown-menu'
        },
        importBtn : {
            type: Boolean,
            default : false
        },
        exportBtn : {
            type: Boolean,
            default : false
        },
        copyBtn : {
            type: Boolean,
            default : false
        },
        multipleSelection : {
            type: Boolean,
            default : true
        },
        newBtn : {
            type: Boolean,
            default : true
        },
        filterFormData : {
            type: Object,
            default : () => ({
                searchTerm : null
            })
        },
        
    },
    components: {
        mdbIcon,
        mdbBtn,
        mdbContainer,
        mdbFormInline,
        mdbDropdown,
        mdbDropdownItem,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbTabs,
        mdbInput,
        mdbNavbar,
      mdbNavbarBrand,
      mdbNavbarToggler,
      mdbNavbarNav,
      mdbNavItem,
      AgGridVue,
      QuantitySetFilter,
      mdbBadge
    },
directives: {
      mdbClickOutside
    },
    created: function () {

         this.dispatchHandler()
        const tokenObj = token();

        this.token = tokenObj.token
        this.setTerm ("");
        this.initColumnVisibility();
    },
    beforeMount() {


        const txt = (field, headerName) => ({
            headerName, field,
            filter: 'agTextColumnFilter',
            condition: 'contains',
            multiple : false,
            /* filterParams: { buttons: ['apply', 'reset', 'clear'] }, */
            filterParams: {
                buttons: ['apply', 'reset', 'clear'],
                suppressAndOrCondition: true, 
                maxNumConditions: 1         
            },
            editable: false,
            minWidth: 150
        })

        const firstUrl = (row) => {
            if (!row) return ''
            if (Array.isArray(row.image) && row.image.length) {
                const i = row.image[0]
                return (typeof i === 'string' ? i : (i.thumb || i.small || i.large || i.url)) || ''
            }
            return row.thumb || (typeof row.image === 'string' ? row.image : '')
            }

            const imgCol = {
                headerName: 'Photo',
                colId: 'img',
                unhidden: true,         
                pinned: 'left',
                width: 84,
                suppressMenu: true,
                filter: false,
                sortable: false,
                resizable: false,
                cellRenderer: params => {
                    const url = firstUrl(params.data)
                    if (!url) return ''
                    const esc = String(url).replace(/"/g, '&quot;')
                    return `<img class="ag-thumb" src="${esc}" />`
                },
                onCellClicked: params => {
                    const r = params.data || {}
                    const arr = Array.isArray(r.image) ? r.image : (r.image ? [r.image] : [])
                    const urls = arr.map(i => (typeof i === 'string' ? i : (i.large || i.url || i.thumb || i.small))).filter(Boolean)
                    if (!urls.length) return
                    this.gallery = urls
                    this.index = 0
                }
                }

    this.columnDefs = [
        {
         headerName: '#',
            colId: '__row',
            unhidden: false,
            hide : true,
            pinned: 'left',
            lockPinned: true,
            lockPosition: true,
            width: 70,
            suppressMenu: true,
            filter: false,
            sortable: false,
            resizable: false,
            cellClass: 'ag-row-number',
            valueGetter: params => {
                const idx  = (params.node ? params.node.rowIndex : 0)
                return idx + 1
            }

        },
         {
            headerName: 'Brand',
            field: 'brand_name',
            unhidden: false,
            hide : false,
            pinned: 'left',
            lockPinned: true,
            lockPosition: true,
            width: 150,
            filter: true,
            sortable: true,
            resizable: true,
            ...pickText('brand_name', 'Brand'),
            cellRendererFramework: CopyCellx
        },
      { headerName: 'SKU', field: 'series', editable: false, ...txt('series', 'Series'), unhidden : true, lockPinned: true, lockPosition: true, width: 100,cellRendererFramework: CopyCellx,onCellClicked: p => this.handleClick(p.data)},
        imgCol,
    //   { headerName: 'Name', field: 'name', editable: false, ...txt('name', 'Name'), unhidden : true, lockPinned: false, lockPosition: true, },
    {
        headerName: 'Name',
        field: 'name',
        ...txt('name', 'Name'),
        unhidden: true,
        lockPinned: false,
        lockPosition: true,
        minWidth: 180,
        flex: 2,                        
        tooltipField: 'name',  
        cellClass: 'name-cell',
        cellRendererFramework: CopyCellx,
        onCellClicked: p => this.handleClick(p.data)
        },
      { headerName: 'Price', field: 'sale_price', editable: false, ...pickPrice('sale_price', 'Sale Price'), valueFormatter: vf2, cellClass: 'ag-num' },
      { field: 'promo_price', editable: false, ...pickPrice('promo_price', 'Promo Price'), headerName: 'Promo Price\nP | S', valueFormatter: promoPriceFormatter, cellRenderer: promoPriceCellRenderer, cellClass: 'ag-num promo-price-cell' },
      {
        headerName: 'Available',
        field: 'available',
        editable: false,
        minWidth: 150,
        ...pick('available', 'Available'),
        headerClass: 'available-header',
        cellClass: 'available-cell text-center align-middle align-center'
      },
      {
        headerName: 'In Stock',
        field: 'stock_qty',
        editable: false,
        minWidth: 150,
        ...pick('stock_qty', 'In Stock'),
        cellClass: params => {
            const value = Number(params && params.value)
            const hasQty = Number.isFinite(value) && value > 0
            return hasQty ? 'stock-clickable-cell stock-has-qty' : 'stock-clickable-cell'
        },
        onCellClicked: params => this.emitValueCellClick(params)
      },
      {
        headerName: 'Ordered',
        field: 'ordered_qty',
        editable: false,
        minWidth: 150,
        ...pick('ordered_qty', 'Ordered'),
        cellClass: params => Number(params && params.value) > 0 ? 'stock-clickable-cell stock-has-qty' : 'stock-clickable-cell',
        onCellClicked: params => this.emitValueCellClick(params)
      },
      {
        headerName: 'Committed',
        field: 'committed_qty',
        editable: false,
        minWidth: 150,
        ...pick('committed_qty', 'Committed'),
        cellClass: params => Number(params && params.value) > 0 ? 'stock-clickable-cell stock-has-qty' : 'stock-clickable-cell',
        onCellClicked: params => this.emitValueCellClick(params)
      },
      {
        headerName: 'In Transit',
        field: 'in_transit_qty',
        editable: false,
        minWidth: 150,
        ...pick('in_transit_qty', 'In Transit'),
        cellClass: params => Number(params && params.value) > 0 ? 'stock-clickable-cell stock-has-qty' : 'stock-clickable-cell',
        onCellClicked: params => this.emitValueCellClick(params)
      },
      { headerName: 'Warehouse', field: 'wh_01', ...pick('wh_01', 'Warehouse') },
      { headerName: 'Showroom', field: 'showroom_qty', editable: false, minWidth: 150, ...pick('showroom_qty', 'Showroom') },
      { headerName: 'Unboxed', field: 'drm_01', editable: false, minWidth: 150, ...pick('drm_01', 'Unboxed') },
      { headerName: 'TLDFC', field: 'sr_01', ...pick('sr_01', 'TLDFC'), hide : true },
      { headerName: 'BHDFC', field: 'sr_02', ...pick('sr_02', 'BHDFC'), hide : true },
      { headerName: 'ECDFC', field: 'sr_03', ...pick('sr_03', 'ECDFC'), hide : true },
      { headerName: 'AMDFC', field: 'sr_04', ...pick('sr_04', 'AMDFC'), hide : true },
      { headerName: 'TADFC', field: 'sr_05', ...pick('sr_05', 'TADFC'), hide : true },
      { headerName: 'AHDFC', field: 'sr_06', ...pick('sr_06', 'AHDFC'), hide : true },
      { headerName: 'BMDFC', field: 'sr_07', ...pick('sr_07', 'BMDFC'), hide : true },
      { headerName: 'RLDFC', field: 'sr_08', ...pick('sr_08', 'RLDFC'), hide : true },
      { headerName: 'CADFC', field: 'sr_09', ...pick('sr_09', 'CADFC'), hide : true },
      { headerName: 'TLKD', field: 'sr_10', ...pick('sr_10', 'TLKD'), hide : true },
      { headerName: 'TCPL', field: 'sr_11', ...pick('sr_11', 'TCPL'), hide : true },
      { headerName: 'LAMS', field: 'sr_13', ...pick('sr_13', 'LAMS'), hide : true },
      { headerName: 'ELDFC', field: 'sr_12', ...pick('sr_12', 'ELDFC'), hide : true },
      { headerName: 'QATL', field: 'git_01', ...pick('git_01', 'QATL'), hide : true },
      

    ]

  },

    mounted(){
        const self = this;
        document.addEventListener('click', this.closeContextMenu)
        document.addEventListener('keydown', this.handleContextMenuKeydown)
        this.$eventBus.$on('created',function(){
        //    self.dispatchHandler();
        location.reload();
        })
        this.$eventBus.$on('reloadTable',function(){
            self.setFilters({});
            //self.refreshTable();
        })
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeContextMenu)
        document.removeEventListener('keydown', this.handleContextMenuKeydown)
    },

    methods: {
        ...mapActions('DisplayedItemsModule',[
            'asyncGetData',
            'resetData',
        ]),
        ...mapMutations('DisplayedItemsModule',[
            'setLength',
            'setPage',
            'setTerm',
            'setSelection',
            'setFilters',
        ]),

         
        getApi() {
            const api = this.gridApi || (this.$refs.model && this.$refs.model.api)
            return api && typeof api.refreshCells === 'function' ? api : null
        },

         initColumnVisibility() {
    this.loadColumnPrefs();
    // sanitize (in case parent changes columns)
    this.checkedFields = this.checkedFields.filter(f => this.allowedFields.includes(f));
    if (this.checkedFields.length === 0) {
      this.checkedFields = [...this.allowedFields];
    }
  },
  handleCheckedChange() {
    this.saveColumnPrefs();
  },
  saveColumnPrefs() {
    try { localStorage.setItem(this.storageKey, JSON.stringify(this.checkedFields)); } catch(e) {}
  },
  loadColumnPrefs() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      this.checkedFields = raw ? JSON.parse(raw) : [...this.allowedFields];
    } catch(e) {
      this.checkedFields = [...this.allowedFields];
    }
  },
  resetColumnPrefs() {
    try { localStorage.removeItem(this.storageKey); } catch(e) {}
    this.checkedFields = [...this.allowedFields];
  },

  // ensure tab switch respects per-tab prefs
  getActiveTabIndex(value){
    this.active = value;
    this.initColumnVisibility();      // <-- ADD
    this.dispatchFilter(this.filterFormData);
  },

        triggerNewEvent(){
            this.$emit('open','new')
        },
        EmitDeleteModal(){
            var self = this;
            MessageBox.confirm('This will permanently delete the file. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        self.$emit('deleteYes',self.selection)
                    }).catch(() => {
                        self.$emit('deleteNo')  
                    });

        },

        async dispatchHandler(){
            this.loading = true
            await this.asyncGetData(this.getRequestEndpoint()).then(() => this.loading = false);
        },
        getRequestEndpoint() {
            const hasQuery = this.endpoint.includes('?')
            const joiner = hasQuery
                ? ((this.endpoint.endsWith('?') || this.endpoint.endsWith('&')) ? '' : '&')
                : '?'
            return `${this.endpoint}${joiner}active=${this.active}&showAll=${this.showAll ? 1 : 0}&showBomComponents=1`
        },
        handleShowAllChange() {
            this.refreshTable()
        },
        handleSizeChange(val) {
            this.setLength(val)
            this.localLength = val
            this.dispatchHandler()
            this.$nextTick(this.refreshRowNums)
        },
        handleCurrentChange(val) {
            this.dispatchHandler()
            this.$nextTick(this.refreshRowNums)
        },
        handleSearchTerm() {
            // this.dispatchHandler()

            console.log("this.filterFormData",{
                ...this.filterFormData,searchTerm : this.term
            })
            this.dispatchFilter({
                ...this.filterFormData,searchTerm : this.term
            })
        },
        handleSelectionChange(val){
            this.setSelection(val)
        },
        ClearSelected(){
            this.$refs.multipleTable.clearSelection();
        },
        emitValueCellClick(params){
            if (!params) return
            const colDef = params.colDef || {}
            const field = colDef.field || (params.column && params.column.getColId && params.column.getColId())
            const clickableFields = ['stock_qty', 'ordered_qty', 'committed_qty', 'in_transit_qty']
            const value = Number(params.value)
            if (!clickableFields.includes(field) || !Number.isFinite(value) || value <= 0) return
            this.$emit('cell-value-click', {
                field: field,
                label: colDef.headerName || field,
                value: params.value,
                row: params.data || {}
            })
        },
        handleClick(row){
            this.$emit('row-click',row)
        },
        handleClickTrigger(index,row,trigger){
            this.$emit('viewWindow',{window:trigger,index : index,row : row})
        },

        /* refreshTable(){
            this.handleClearFilterForm();
        }, */

        async refreshTable () {
            this.loading = true
            try {
                // re-fetch using current endpoint/active tab and (importantly) keep existing filters in your store
                await this.resetData(this.getRequestEndpoint())
            } finally {
                this.loading = false
                this.$nextTick(() => {
                this.refreshRowNums()
                if (this.gridApi) this.gridApi.refreshCells({ force: true })
                })
            }
            },
        copyTable() {
            const rows = this.getCopyRows()

            const columns = this.getCopyColumns()
            if (!rows.length || !columns.length) {
                Message.warning({ message: 'There is no table data to copy.' })
                return
            }

            this.copyRowsToClipboard(rows, columns, `Copied ${rows.length} rows to clipboard.`)
        },
        getCopyRows() {
            const rows = []
            const api = this.gridApi || (this.$refs.model && this.$refs.model.api)

            if (api && typeof api.forEachNodeAfterFilterAndSort === 'function') {
                api.forEachNodeAfterFilterAndSort(node => {
                    if (node && node.data) rows.push(node.data)
                })
            } else if (Array.isArray(this.modelRowData)) {
                rows.push(...this.modelRowData)
            }

            return rows
        },
        buildCopyText(rows, columns, includeHeaders) {
            const values = rows.map(row => columns.map(column => this.getCopyCellValue(row, column)))
            const lines = values.map(row => row.join('\t'))

            if (includeHeaders) {
                lines.unshift(columns.map(column => this.copyCellValue(column.header)).join('\t'))
            }

            return lines.join('\n')
        },
        getCopyCellValue(row, column) {
            let value = row[column.field]
            const definition = column.definition

            if (definition && typeof definition.valueFormatter === 'function') {
                try {
                    value = definition.valueFormatter({
                        value: value,
                        data: row,
                        colDef: definition
                    })
                } catch (e) {
                    // Keep the raw value when a grid formatter needs runtime-only context.
                }
            }

            return this.copyCellValue(value)
        },
        copyRowsToClipboard(rows, columns, successMessage, includeHeaders) {
            const text = this.buildCopyText(rows, columns, includeHeaders !== false)

            this.writeClipboardText(text).then(copied => {
                if (copied) {
                    Message.success({ message: successMessage })
                } else {
                    Message.error({ message: 'Unable to copy table data.' })
                }
            })
        },
        handleGridCellContextMenu(params) {
            if (!this.copyBtn || !params || !params.node || !params.column) return

            if (params.event && typeof params.event.preventDefault === 'function') {
                params.event.preventDefault()
            }

            const definition = params.colDef || (params.column.getColDef && params.column.getColDef()) || {}
            const columnId = params.column.getColId()
            const field = definition.field || (columnId === 'img' ? 'thumb' : null)
            if (!field) return
            const clientX = params.event && Number.isFinite(params.event.clientX) ? params.event.clientX : 8
            const clientY = params.event && Number.isFinite(params.event.clientY) ? params.event.clientY : 8
            const menuWidth = 220
            const menuHeight = 150

            this.contextMenu = {
                visible: true,
                x: Math.max(8, Math.min(clientX, window.innerWidth - menuWidth - 8)),
                y: Math.max(8, Math.min(clientY, window.innerHeight - menuHeight - 8)),
                rowIndex: this.getGridRowIndex(params.node),
                header: definition.headerName || columnId,
                field: field,
                value: params.value,
                row: params.node.data,
                definition: definition
            }
        },
        suppressBrowserContextMenu(event) {
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault()
            }
        },
        getGridRowIndex(node) {
            const rows = this.getCopyRows()
            const rowIndex = rows.indexOf(node && node.data)
            if (rowIndex >= 0) return rowIndex + 1
            if (node && Number.isFinite(node.rowIndex)) return node.rowIndex + 1
            return 0
        },
        closeContextMenu() {
            if (this.contextMenu.visible) this.contextMenu.visible = false
        },
        handleContextMenuKeydown(event) {
            if (event.key === 'Escape') this.closeContextMenu()
        },
        copyContextCell() {
            const context = this.contextMenu
            this.closeContextMenu()
            if (!context.row || !context.field) return

            this.copyRowsToClipboard([context.row], [{
                field: context.field,
                header: context.header,
                definition: context.definition
            }], 'Copied cell.', false)
        },
        copyContextColumn() {
            const context = this.contextMenu
            this.closeContextMenu()
            if (!context.field) return

            this.copyRowsToClipboard(this.getCopyRows(), [{
                field: context.field,
                header: context.header,
                definition: context.definition
            }], `Copied ${context.header} column.`)
        },
        copyContextRow() {
            const context = this.contextMenu
            this.closeContextMenu()
            if (!context.row) return

            this.copyRowsToClipboard([context.row], this.getCopyColumns(), `Copied row ${context.rowIndex}.`)
        },
        copyContextTable() {
            this.closeContextMenu()
            this.copyTable()
        },
        getCopyColumns() {
            const columns = this.columnApi && typeof this.columnApi.getAllDisplayedColumns === 'function'
                ? this.columnApi.getAllDisplayedColumns()
                : (this.columnDefs || []).filter(column => !column.hide)

            return columns.map(column => {
                const definition = typeof column.getColDef === 'function'
                    ? (column.getColDef() || {})
                    : column
                const field = definition.field

                if (!field) return null

                return {
                    field: field,
                    header: definition.headerName || field,
                    definition: definition
                }
            }).filter(Boolean)
        },
        copyCellValue(value) {
            if (value === null || value === undefined) return ''
            if (Array.isArray(value)) return value.map(item => this.copyCellValue(item)).join(', ')
            if (typeof value === 'object') return JSON.stringify(value)

            return String(value)
                .replace(/[\r\n]+/g, ' ')
                .replace(/\t/g, ' ')
        },
        writeClipboardText(text) {
            if (navigator.clipboard && window.isSecureContext) {
                return navigator.clipboard.writeText(text).then(() => true).catch(() => false)
            }

            return new Promise(resolve => {
                const textarea = document.createElement('textarea')
                textarea.value = text
                textarea.setAttribute('readonly', '')
                textarea.style.position = 'fixed'
                textarea.style.opacity = '0'
                document.body.appendChild(textarea)
                textarea.select()

                let copied = false
                try {
                    copied = document.execCommand('copy')
                } catch (e) {
                    copied = false
                }

                document.body.removeChild(textarea)
                resolve(copied)
            })
        },
        emitStatus(status){
            this.$emit('status',status)
        },

        getValue(scope,string){
            var result = string.split(".");
            const response = [];
            result.forEach(element => {
                response.push(element)
            });

            return scope.row.response;
        },

        toggleDropdown(){
            this.toggle = !this.toggle;
        },

        away(){
            this.toggle = false
        },

        dispatchFilter(filters){
            this.setFilters(filters)
            this.loading = true
             this.resetData(this.getRequestEndpoint()).then(() => this.loading = false);
        },
        emitImport(){
            this.$emit('import')
        },
        emitExport(){
            // this.$emit('export')

             window.open(this.endpoint+"/export", "_blank");  
        },

        downloadFile(response, filename,ext) {

            var newBlob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'})

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob)
                return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            var link = document.createElement('a')
            link.href = data
            link.download = filename + '.xlsx'
            link.click()
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
            }, 100)
            },
        openFilterDialog(){
            this.filterDialog = true
        },
        closeFilterDialog(){
            this.filterDialog = false
        },

        handleFilterForm(){
            // console.log(this.filterFormData)
            this.filterDialog = false
            this.dispatchFilter(this.filterFormData)
        },
        handleClearFilterForm(){
            // this.$emit('clearFilterForm')

            // console.log("this.filterFormData",this.filterFormData)
            this.$nextTick(() => {
               /*  this.dispatchFilter({
                    searchTerm : null,
                    SuppCatNum : null,
                    U_PRT_GroupId : "ALL",
                    U_PRT_BrandId : "ALL",
                    U_PRT_CollectionId : "ALL",
                    U_PRT_CategoryId : "ALL",
                }) */
                this.$emit('clearFilterForm')
                this.term = ''
            })
        },
        viewImage(index,row){
            const self = this;
            if(row.image.length > 0){
                self.gallery = row.image.map((i) => {
                    return i.large
                });
                this.index = 0;
            }
        },
        viewSoldTo(row){
            this.$emit('viewSoldTo',row)
        },
        viewRelatedDocument(reference,row){
            this.$emit('viewRelatedDocument',{reference : reference, row : row})
        },



       tableSearchTerm : function(event){
            // console.log("tableSearchTearm",event.target.value)
            this.$emit('tableSearchTerm',event.target.value)
        },
        isFilterable(column){
            return this.filterableColumns.includes(column.field)
        },

        filterHandler(value, row) {
        return row.status === value;
        },
        filterWarehouse(value, row) {
            console.log("filterWarehouse",value)
            const parsedValue = parseInt(value);
            const rowValue = parseInt(row.wh_01);
            return rowValue === parsedValue;
        },
        filterWh01(values, row) {
            console.log("filterWarehouse",values)
            const rowValue = parseInt(row.wh_01);
             if (!Array.isArray(values) || values.length === 0) return true;
            return values.some(v => Number(v) === rowValue);
        },
        filterWh02(values, row) {
            const rowValue = parseInt(row.wh_02);
             if (!Array.isArray(values) || values.length === 0) return true;
            return values.some(v => Number(v) === rowValue);
        },
        filterWh03(values, row) {
            const rowValue = parseInt(row.wh_03);
            if (!Array.isArray(values) || values.length === 0) return true;
            return values.some(v => Number(v) === rowValue);
        },
        filterNumeric(value, row, column) {
             
            const prop = column.property;
            const rowValue = Number(row[prop]);
            const parsedValue = parseInt(value);
            return rowValue === parsedValue;
        },
        getVisibleRows() {
            return this.$refs.multipleTable.store.states.data; 
        },
        

        getUniqueColumnValues(field, respectOtherFilters) {
            if (!this.$refs.model || !this.$refs.model.api) return [];
            const api   = this.$refs.model.api;
            const seen  = Object.create(null);
            const iter  = respectOtherFilters ? api.forEachNodeAfterFilter : api.forEachNode;

            iter.call(api, function(node){
            if (!node || !node.data) return;
            const raw = node.data[field];
            if (raw === null || raw === undefined) return;
            const num = Number(raw);
            if (!isNaN(num)) seen[num] = true;
            });

            return Object.keys(seen)
            .map(function(k){ return Number(k); })
            .sort(function(a,b){ return a - b; });
        },

        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
            this.$nextTick(() => {
                this.initColumnVisibilityAG()
                this.ensurePinnedLeft()
                this.refreshRowNums()
            })
        },
        initColumnVisibilityAG() {
            if (!this.columnApi) return

            const allCols = this.columnApi.getAllGridColumns()
                .filter(c => !(c.getColDef() && c.getColDef().autoGroup))
            const allIds = allCols.map(c => c.getColId())
            const lockedIds = allCols
                .filter(c => !!(c.getColDef() && c.getColDef().unhidden))
                .map(c => c.getColId())

            const defaultHidden = new Set(
                allCols
                .filter(c => (c.getColDef() || {}).hide === true)
                .map(c => c.getColId())
            )

            const defaultVisibleIds = allCols
                .filter(c => {
                const d = c.getColDef() || {}
                return d.unhidden === true || d.hide !== true
                })
                .map(c => c.getColId())

            const raw = localStorage.getItem(this.agStorageKey)
            let visible = []
            if (raw) {
                try { visible = JSON.parse(raw) || [] } catch(e) { visible = [] }
                // sanitize + respect hide:true
                visible = visible
                .filter(id => allIds.includes(id))
                .filter(id => !defaultHidden.has(id))   // <-- key line
                // add any new non-hidden columns
                const newIds = allIds.filter(id => !visible.includes(id))
                const newVisible = newIds.filter(id => !defaultHidden.has(id))
                visible = [...new Set([...visible, ...newVisible])]
            } else {
                visible = defaultVisibleIds.slice()
            }

            // always include locked/unhidden
            visible = [...new Set([...visible, ...lockedIds])]
            if (!visible.length) visible = [...lockedIds]

            this.checkedFieldsAG = visible.slice()
            this.applyColumnPrefsAG()
            },
        /* initColumnVisibilityAG() {
  if (!this.columnApi) return

  // all column ids + “locked/unhidden” ids
  const allCols = this.columnApi.getAllGridColumns()
    .filter(c => !(c.getColDef() && c.getColDef().autoGroup))
  const allIds = allCols.map(c => c.getColId())
  const lockedIds = allCols
    .filter(c => !!(c.getColDef() && c.getColDef().unhidden))
    .map(c => c.getColId())

  // default visible = not hidden OR explicitly unhidden
  const defaultVisibleIds = allCols
    .filter(c => {
      const d = c.getColDef() || {}
      return d.unhidden === true || d.hide !== true
    })
    .map(c => c.getColId())

  // read saved
  const raw = localStorage.getItem(this.agStorageKey)
  let visible = []
  if (raw) {
    try { visible = JSON.parse(raw) || [] } catch(e) { visible = [] }
    // sanitize
    visible = visible.filter(id => allIds.includes(id))
    // add any new columns that are NOT hidden by default
    const newIds = allIds.filter(id => !visible.includes(id))
    const newVisible = newIds.filter(id => {
      const col = allCols.find(c => c.getColId() === id)
      const def = col && col.getColDef()
      return def && (def.unhidden === true || def.hide !== true)
    })
    visible = [...new Set([...visible, ...newVisible])]
  } else {
    // first load: use defaults
    visible = defaultVisibleIds.slice()
  }

  // always include locked/unhidden
  visible = [...new Set([...visible, ...lockedIds])]
  if (!visible.length) visible = [...lockedIds]

  this.checkedFieldsAG = visible.slice()
  this.applyColumnPrefsAG()
}, */
       /*  initColumnVisibilityAG() {
  if (!this.columnApi) return
  const allIds    = this.columnChoices.map(c => c.id)
  const lockedIds = this.columnChoices.filter(c => c.locked).map(c => c.id)

  const raw = localStorage.getItem(this.agStorageKey)
  let visible = []
  if (raw) {
    try { visible = JSON.parse(raw) || [] } catch(e) { visible = [] }
  } else {
    visible = this.columnApi.getAllDisplayedColumns().map(c => c.getColId())
    if (!visible.length) visible = allIds.slice()
  }

  // sanitize & ADD newly introduced columns (e.g., "img")
  visible = visible.filter(id => allIds.includes(id))
  const newIds = allIds.filter(id => !visible.includes(id))
  visible = [...visible, ...newIds]

  // always include locked/unhidden columns
  visible = Array.from(new Set([...visible, ...lockedIds]))
  if (!visible.length) visible = [...lockedIds]

  this.checkedFieldsAG = visible.slice()
  this.applyColumnPrefsAG()
},
 */
        /* initColumnVisibilityAG() {
  if (!this.columnApi) return
  const allIds    = this.columnChoices.map(c => c.id)
  const lockedIds = this.columnChoices.filter(c => c.locked).map(c => c.id)

  const raw = localStorage.getItem(this.agStorageKey)
  let visible = []
  if (raw) {
    try { visible = JSON.parse(raw) || [] } catch(e) { visible = [] }
  } else {
    visible = this.columnApi.getAllDisplayedColumns().map(c => c.getColId())
    if (!visible.length) visible = allIds.slice()
  }

  visible = visible.filter(id => allIds.includes(id))
  visible = Array.from(new Set([...visible, ...lockedIds]))
  if (!visible.length) visible = [...lockedIds]

  this.checkedFieldsAG = visible.slice()
  this.applyColumnPrefsAG()
}, */

applyColumnPrefsAG() {
    if (!this.columnApi) return
    const allIds = this.columnChoices.map(c => c.id)
    const selected = new Set(this.checkedFieldsAG)

    this.columnApi.setColumnsVisible(allIds, false)
    this.columnApi.setColumnsVisible(Array.from(selected), true)

    // keep Series/Name visible and pinned (unhidden already disables their checkboxes)
    this.ensurePinnedLeft()

    try { localStorage.setItem(this.agStorageKey, JSON.stringify(this.checkedFieldsAG)) } catch(e) {}
  },

  ensurePinnedLeft() {
  if (!this.columnApi) return
  const desired = ['__row','brand_name','series','img','name']
  const existing = this.columnApi.getAllGridColumns().map(c => c.getColId())
  const present  = desired.filter(id => existing.includes(id))

  // Pin first 3, unpin name; also apply ordering
  const state = present.map(colId => ({
    colId,
    pinned: (colId === 'name') ? null : 'left'
  }))

  this.columnApi.applyColumnState({ state, applyOrder: true })
  this.columnApi.moveColumns(present, 0)
},

/*   ensurePinnedLeft() {
    if (!this.columnApi) return
    // make sure they’re pinned and first
    this.columnApi.applyColumnState({
      state: [
          { colId: 'img', pinned: 'left' },
        { colId: 'series', pinned: 'left' },
        { colId: 'name',   pinned: 'left' },
      ],
      applyOrder: true
    })
    // this.columnApi.moveColumns(['series','name'], 0) 
    this.columnApi.moveColumns(['__row','img','series','name'], 0)

    if (!this.columnApi) return
  const desired = ['__row','img','series','name']
  const existing = this.columnApi.getAllGridColumns().map(c => c.getColId())
  const present = desired.filter(id => existing.includes(id))
  this.columnApi.applyColumnState({ state: present.map(colId => ({ colId, pinned: 'left' })), applyOrder: true })
  this.columnApi.moveColumns(present, 0)
  }, */

onCheckAllAG(v) {
  const lockedIds = this.columnChoices.filter(c => c.locked).map(c => c.id)
  const toggleable = this.columnChoices.filter(c => !c.locked).map(c => c.id)
  this.checkedFieldsAG = v ? [...toggleable, ...lockedIds] : [...lockedIds]
  this.applyColumnPrefsAG()
},

/* resetColumnPrefsAG() {
  if (!this.columnApi) return
  const lockedIds = this.columnChoices.filter(c => c.locked).map(c => c.id)
  const toggleable = this.columnChoices.filter(c => !c.locked).map(c => c.id)
  this.checkedFieldsAG = [...toggleable, ...lockedIds]
  this.applyColumnPrefsAG()
}, */
resetColumnPrefsAG() {
  if (!this.columnApi) return
  const allCols = this.columnApi.getAllGridColumns()
    .filter(c => !(c.getColDef() && c.getColDef().autoGroup))
  const lockedIds = allCols
    .filter(c => !!(c.getColDef() && c.getColDef().unhidden))
    .map(c => c.getColId())
  const defaultVisibleIds = allCols
    .filter(c => {
      const d = c.getColDef() || {}
      return d.unhidden === true || d.hide !== true
    })
    .map(c => c.getColId())

    this.checkedFieldsAG = [...new Set([...defaultVisibleIds, ...lockedIds])]
    this.applyColumnPrefsAG()
    },

    async clearAllFilters() {
  this.filterDialog = false;
  this.$emit('clearFilterForm');
  this.term = '';

  const api = this.gridApi || (this.$refs.model && this.$refs.model.api);
  if (!api) return;

  // Clear quick filter and all column filters in one go
  api.setQuickFilter('');
  api.setFilterModel(null);   // this resets built-in + any *existing* custom filters
  api.onFilterChanged();

  // If you keep any local UI state, clear it
  if (this.selectedFilters && typeof this.selectedFilters === 'object') {
    Object.keys(this.selectedFilters).forEach(k => this.$set(this.selectedFilters, k, []));
  }

  // Reset store-side filters and refetch
  this.setFilters({});
  this.loading = true;
  try {
    await this.resetData(this.getRequestEndpoint());
  } finally {
    this.loading = false;
    this.$nextTick(() => {
      this.refreshRowNums();
      if (this.gridApi) this.gridApi.refreshCells({ force: true });
    });
  }
}
,

       /*  clearAllFilters() {

            this.handleClearFilterForm();
            

            const api = this.gridApi || (this.$refs.model && this.$refs.model.api)
            const colApi = this.columnApi || (this.$refs.model && this.$refs.model.columnApi)
            if (!api) return

            // 1) Clear global models
            // (Some AG Grid versions prefer {} over null—do both to be safe.)
            api.setFilterModel(null)
            api.setQuickFilter('')
            api.setFilterModel({})

            // 2) Hard reset every column’s filter instance (covers custom Vue filters)
            if (colApi) {
                const cols = colApi.getAllGridColumns() || []
                cols.forEach(col => {
                const colId = col.getColId()
                api.getFilterInstance(colId, instance => {
                    if (!instance) return
                    // Tell the filter it has no state
                    if (typeof instance.setModel === 'function') instance.setModel(null)
                    // If your custom filter exposes a reset hook, call it (optional)
                    if (typeof instance.onReset === 'function') instance.onReset()
                })
                // Force the filter UI to rebuild on next open (optional but very reliable)
                api.destroyFilter(colId)
                })
            }

            // 3) Apply & refresh
            api.onFilterChanged()

            // 4) Clear any external UI filter state you keep
            if (this.selectedFilters && typeof this.selectedFilters === 'object') {
                Object.keys(this.selectedFilters).forEach(k => this.$set(this.selectedFilters, k, []))
            }

            
        }, */

        refreshRowNums() {
             if (!this.gridApi) return
            this.gridApi.refreshCells({ columns: ['__row'], force: true })
        },
        onRowClicked(p) { 
            const id = (p.column && p.column.getColId && p.column.getColId()) || p.colDef?.field
            if (id === 'series' || id === 'name') this.handleClick(p.data)
        }


    },
    
    computed: {
        ...mapGetters('DisplayedItemsModule',[
            'data',
            'page',
            'total',
            'length',
            'searchTerm',
            'selection',
        ]),
        ...mapGetters('DisplayedItemsModule',{invloading : 'loading'}),
        term : {
            get : function(){
               return this.searchTerm
            },
            set : function(val){
                this.setTerm (val)
            }
        },
        current_page : {
            get : function(){
               return this.page
            },
            set : function(val){
                this.setPage (val)
            }
        },

        hasFilterSlot() {
            return ('filter' in this.$scopedSlots);
        },

        hasButtonRightSlot() {
            return ('button-right' in this.$scopedSlots);
        },

        hasTabsSlot() {
            return ('tabs' in this.$scopedSlots);
        },
        hasCustomColumnsSlot() {
            return ('custom-culumns' in this.$scopedSlots);
        },

        hasRightCustomColumnsSlot() {
            return ('custom-right-culumns' in this.$scopedSlots);
        },
        visibleColumns() {
            if (!Array.isArray(this.columns)) return [];
            const all = this.columns.map(c => c.field);
            const active = this.checkedFields.length ? new Set(this.checkedFields) : new Set(all);
            return this.columns.filter(c => active.has(c.field));
        },

        // Convenience lists & checkbox state
        allowedFields() {
            return Array.isArray(this.columns) ? this.columns.map(c => c.field) : [];
        },
        isIndeterminate() {
            const len = this.checkedFields.length, total = this.allowedFields.length;
            return len > 0 && len < total;
        },
        checkAll: {
            get() {
            return this.allowedFields.length > 0 &&
                    this.checkedFields.length === this.allowedFields.length;
            },
            set(val) {
            this.checkedFields = val ? [...this.allowedFields] : [];
            this.saveColumnPrefs();
            }
        },
        storageKey() {
            return `colvis:${this.endpoint}:${this.active}`;
        },

        fltrWarehouse() {
            if (!this.data?.rows?.length) return [];
            const uniqueValues = [...new Set(this.data.rows.map(r => Number(r.wh_01)))];
            return uniqueValues.map(v => ({
                text: v,    
                value: v,  
            }));
        },
        
        displayedRows() {
            const rows   = this.$refs.multipleTable
            ? this.$refs.multipleTable.store.states.data
            : this.data.rows || [];
            console.log("displayedRows",rows)   
            return rows;
        },

        columnFilters() {
            const filters = {};
            if (!this.displayedRows.length) return filters;

            this.filterableColumns.forEach(key => {
            const uniqueValues = [...new Set(this.displayedRows.map(r => Number(r[key])))];
            filters[key] = uniqueValues
                .filter(v => !isNaN(v))
                .sort((a, b) => a - b)
                .map(v => ({ text: v, value: v }));
            });

            return filters;
        },
        /* availableOptions() {
            if (!this.$refs.model?.api) return [];
            const set = new Set();
            this.$refs.model.api.forEachNodeAfterFilter(node => {
            const v = node.data?.available;
            if (v !== null && v !== undefined && !Number.isNaN(Number(v))) set.add(Number(v));
            });
            return [...set].sort((a, b) => a - b).map(v => ({ text: v, value: v }));
        }, */

        availableOptions() {
            var vals = this.getUniqueColumnValues('available', true); // respects other filters
            return vals.map(function(v){ return { text: v, value: v }; });
        },

       /*  agStorageKey() {
            return `agcolvis:${this.endpoint}:${this.active}`
        }, */
        agStorageKey() {
            const ver = 'v2' 
            return `agcolvis:${ver}:${this.endpoint}:${this.active}`
            },
        columnChoices() {
            if (!this.columnApi) {
                return (this.columnDefs || [])
                .map(c => ({
                    id: c.colId || c.field,
                    label: c.headerName || c.field || c.colId,
                    locked: !!c.unhidden
                }))
                .filter(c => !!c.id)
            }

            return this.columnApi.getAllGridColumns()
                .filter(col => !(col.getColDef() && col.getColDef().autoGroup))
                .map(col => {
                const def = col.getColDef() || {}
                return {
                    id: col.getColId(),
                    label: def.headerName || def.field || col.getColId(),
                    locked: !!def.unhidden
                }
                })
        },
        isIndeterminateAG() {
            const toggleable = this.columnChoices.filter(c => !c.locked).map(c => c.id)
            const set = new Set(toggleable)
            const selectedToggleable = this.checkedFieldsAG.filter(id => set.has(id)).length
            return toggleable.length > 0 && selectedToggleable > 0 && selectedToggleable < toggleable.length
            },
            checkAllAG: {
            get() {
                const toggleable = this.columnChoices.filter(c => !c.locked).map(c => c.id)
                const set = new Set(toggleable)
                const selectedToggleable = this.checkedFieldsAG.filter(id => set.has(id)).length
                return toggleable.length > 0 && selectedToggleable === toggleable.length
            },
            set(v) { this.onCheckAllAG(v) }
            },


        brands : function(){
            const b = this.brandProvider();
            if(["ALL"].includes(this.filterForm.U_PRT_GroupId)){
                return [...[
                {code : "ALL", brand : "ALL", parent : 0},
                ],...b];
            }else{
                const filteredData = b.filter((item) => item.parent === this.filterForm.U_PRT_GroupId,[])
                return [...[
                    {code : "ALL", brand : "ALL", parent : 0},
                ],...filteredData];
            }
        },
        groups : function(){
            const brandProviderData = this.brandProvider();
            const g = brandProviderData.filter((item) => item.parent == 0,[])
            return [...[
                {code : "ALL", brand : "ALL", parent : 0},
            ],...g]
        },

        categoryComputed : function(){
            return this.categoryProvider();
        },
        areaComputed : function(){
            return this.areaProvider();
        },

        collections : function(){
            const c = this.collectionProvider();
            if(["ALL"].includes(this.filterForm.U_PRT_BrandId)){
                return [...[
                {mdbID : "ALL",name : "ALL", brand_id : 0},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brand_id == this.filterForm.U_PRT_BrandId,[])
                return [...[
                    {mdbID : "ALL",name : "ALL", brand_id : 0},
                ],...filteredData];
            }


        },

        filteredCategory : function(){

            const c = this.filteredCategoryProvider();

            if(["ALL"].includes(this.filterForm.U_PRT_BrandId)){
                return [...[
                {id : "ALL",name : "ALL", attributes : []},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brands.includes(this.filterForm.U_PRT_BrandId),[])
                return [...[
                    {id : "ALL",name : "ALL", attributes : []},
                ],...filteredData];
            }
        },
    },

    watch : {
        columns: {
            handler() { this.initColumnVisibility(); },
            deep: true
        },
        active() {
            this.initColumnVisibility();
        }, 
        "data.rows" : {
            handler(value) {
                // this.initColumnVisibility();
                // console.log("data.rows",value)
                this.modelRowData = value.map(row => ({
                        "brand_name" : row.brand_name,
                        "series" : row.series,
                        "name" : row.name,                        
                        "sale_price" : Number(row.sale_price),
                        "promo_price" : Number(row.promo_price),
                        "silent_promo_price" : Number(row.silent_promo_price),
                        "public_promo_price" : Number(row.public_promo_price),
                        "available" : Number(row.available),
                        "stock_qty" : Number(row.stock_qty),
                        "ordered_qty" : Number(row.ordered_qty),
                        "committed_qty" : Number(row.committed_qty),
                        "in_transit_qty" : Number(row.in_transit_qty),
                        "wh_01" : Number(row.wh_01),
                        "showroom_qty" : Number(row.showroom_qty),
                        "drm_01" : Number(row.drm_01),
                        "sr_01" : Number(row.sr_01),
                        "sr_02" : Number(row.sr_02),
                        "sr_03" : Number(row.sr_03),
                        "sr_04" : Number(row.sr_04),
                        "sr_05" : Number(row.sr_05),
                        "sr_06" : Number(row.sr_06),
                        "sr_07" : Number(row.sr_07),
                        "sr_08" : Number(row.sr_08),
                        "sr_09" : Number(row.sr_09),
                        "sr_10" : Number(row.sr_10),
                        "sr_11" : Number(row.sr_11),
                        "sr_12" : Number(row.sr_12),
                        "sr_13" : Number(row.sr_13),
                        "git_01" : Number(row.git_01),
                       
                       /*  "sale_price" : Number(row.sale_price),
                        "promo_price" : Number(row.promo_price),
                        "available" : Number(row.available),
                        "stock_qty" : Number(row.stock_qty),
                        "showroom_qty" : Number(row.showroom_qty),
                        "git_01" : Number(row.git_01),
                        "sr_01" : Number(row.sr_01),
                        "sr_02" : Number(row.sr_02),
                        "sr_03" : Number(row.sr_03),
                        "sr_04" : Number(row.sr_04),
                        "sr_05" : Number(row.sr_05),
                        "sr_06" : Number(row.sr_06),
                        "sr_07" : Number(row.sr_07),
                        "sr_08" : Number(row.sr_08),
                        "sr_09" : Number(row.sr_09),
                        "sr_10" : Number(row.sr_10),
                        "sr_11" : Number(row.sr_11),
                        "sr_12" : Number(row.sr_12),
                        "sr_13" : Number(row.sr_13),
                        "wh_01" : Number(row.wh_01), */
                        image: row.image,
                        thumb: row.thumb || ''
                }));
                 this.$nextTick(this.refreshRowNums)
            },
            deep: true
        },
        /* 'selectedFilters.available': {
            handler() { this.applyAvailableFilter() },
            deep: true
        } */
                
    }

}
</script>
<style scoped>
.table-container{ padding : 0 5px } .custom-element-table{ position: relative; }
</style>

<style>
.dropdown-menu.show{
    top:100%!important;
    position:absolute!important;
}

.select-store .dropdown-menu {
    position: relative!important;
}

.dropdown-menu.sf-dropdown-menu{
    min-width: 600px;background-color: #f3f3f3;
}
.form-control.table-searchterm-input{
    align-self: flex-start!important;
    margin-top: 2px!important;
}

.colvis-pop .el-checkbox { display:block; margin:4px 0; }
.colvis-scroll { max-height: 260px; overflow:auto; }
.show-all-toggle { vertical-align: middle; }

.inventory-grid-context-menu {
    position: fixed;
    z-index: 3000;
    min-width: 220px;
    padding: 6px 0;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .18);
}

.inventory-grid-context-menu-location {
    padding: 6px 14px;
    color: #909399;
    font-size: 11px;
    border-bottom: 1px solid #ebeef5;
}

.inventory-grid-context-menu button {
    display: block;
    width: 100%;
    padding: 8px 14px;
    color: #303133;
    font-size: 13px;
    text-align: left;
    background: transparent;
    border: 0;
    cursor: pointer;
}

.inventory-grid-context-menu button:hover {
    color: #409eff;
    background: #f5f7fa;
}

.ag-thumb { width: 64px; height: 64px; object-fit: contain; display: block; margin: 0 auto; border-radius: 6px; }

.value-filters { display: flex; gap: 8px; align-items: center; justify-content: flex-end;}
.vf-row { display: flex; gap: 8px; align-items: center; }
.vf-cell { min-width: 160px; }
.vf-clear { margin-left: 4px; }

/* .ag-ellipsis {
  flex: 1 1 auto;
  min-width: 0;              
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
 */
/* optional: ensure numeric cells still right-aligned, row number aligned, etc. */
.ag-theme-alpine .ag-cell { display: flex; align-items: center; }
.ag-theme-alpine .ag-cell.ag-num { justify-content: flex-end; }
.ag-theme-alpine .ag-cell.ag-row-number { justify-content: flex-end; padding-right: 8px; }

.inventory-by-warehouse-grid .ag-theme-alpine .ag-ltr .ag-cell {
    border-right-color: #d1d5db;
}

.inventory-by-warehouse-grid .ag-theme-alpine .ag-rtl .ag-cell {
    border-left-color: #d1d5db;
}

.inventory-by-warehouse-grid .ag-theme-alpine .ag-row {
    border-bottom-color: #d1d5db;
}

.inventory-by-warehouse-grid .ag-theme-alpine .ag-ltr .ag-header-cell {
    border-right: 1px solid #d1d5db;
}

.inventory-by-warehouse-grid .ag-theme-alpine .ag-rtl .ag-header-cell {
    border-left: 1px solid #d1d5db;
}

.ag-theme-alpine .ag-cell.name-cell .ag-cell-wrapper {
  min-width: 0;
  flex: 1 1 auto;
}

/* ellipsize the value */
.ag-theme-alpine .ag-cell.name-cell .ag-cell-value {
    display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* clip anything extra just in case */
.ag-theme-alpine .ag-header-cell.ag-header-cell-filtered {
    background-color : #dbeafe
}

.ag-theme-alpine .ag-cell.name-cell {
    overflow: hidden;
}

.ag-theme-alpine .ag-cell.ag-cell-value span span.copy {
    position: absolute;
    display: block;
    top: 10px;
    right: 0;
    background: #00a7f7;
    font-weight: bold;
    padding: 2px 5px;
    color: #fff;
    line-height: 15px;
    border-radius: 5px;
    opacity: 0;
    cursor: pointer;
    }

.ag-theme-alpine .ag-cell.ag-cell-value:hover span span.ag-ellipsis {
    text-decoration : underline
}
.ag-theme-alpine .ag-cell.ag-cell-value:hover span span.copy {
    opacity: 1;
    }

.ag-theme-alpine .ag-cell.stock-clickable-cell {
    cursor: pointer;
    color: #00a7f7;
    font-weight: 600;
}

.ag-theme-alpine .ag-cell.stock-clickable-cell:hover {
    text-decoration: underline;
}

.ag-theme-alpine .ag-cell.stock-clickable-cell.stock-has-qty {
    color: #00a7f7;
    font-weight: 700;
}

.ag-theme-alpine .ag-cell.available-cell {
    color: #2F4A1E;
    background-color: rgb(225, 246, 231);
    font-weight: 700;
    transition: color .15s ease, background-color .15s ease;
}

.ag-theme-alpine .ag-row-hover .ag-cell.available-cell,
.ag-theme-alpine .ag-cell.available-cell:hover {
    color: rgb(29, 139, 72);
    background-color: rgb(205, 238, 215)#E2EFDA;
}

.ag-theme-alpine .ag-header-cell.available-header {
    color: #2F4A1E;
    background-color: rgb(225, 246, 231);
    font-weight: 700;
    transition: color .15s ease, background-color .15s ease;
}

.ag-theme-alpine .ag-header-cell.available-header:hover {
    color: rgb(29, 139, 72);
    background-color: rgb(205, 238, 215);
}

.ag-theme-alpine .ag-cell.promo-price-cell .ag-cell-value {
    white-space: pre-line;
    line-height: 1.35;
}

.ag-theme-alpine .ag-cell.promo-price-cell .promo-price-renderer {
    line-height: 1.35;
    white-space: normal;
    width: 100%;
    text-align: right;
}

/* 

table tbody tr td span.copy {
  position: absolute;
  display: block;
  top: 10px;
  right: 0;
  background: #00a7f7;
  font-weight: bold;
  padding: 2px 5px;
  color: #fff;
  line-height: 15px;
  border-radius: 5px;
  opacity: 0;
  cursor: pointer;
}

table tbody tr td:hover .copy {
  opacity: 1;
}


*/
</style>
